import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

export const getAccountState = (state: RootState) => state.Account

export const getFeedbackState = createSelector(
  getAccountState,
  state => state.feedback
)

export const getDeleteAccountState = createSelector(
  getAccountState,
  state => state.deleteAccount
)
